export const HTTP_METHODS = {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    PATCH: "PATCH",
    DELETE: "DELETE",
  } as const;
  
  export type HttpMethod = typeof HTTP_METHODS[keyof typeof HTTP_METHODS];
  